import React, { useEffect, useState } from "react";
import axios from "axios";
import { FavoriteJob, Job } from "interfaces/jobs";
import { Col, List, Empty, Typography, Card, Row, Button } from "antd";
import SingleJobPostingBox from "containers/JobPostings/SingleJobPostingBox/SingleJobPostingBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";

const { Title } = Typography;

const MyFavorites = () => {
  const [favoriteJobs, setFavoriteJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchFavorites = async () => {
      setLoading(true);
      try {
        const favoriteJobsResponse = await axios.get<FavoriteJob[]>("/jobs/favorites/");
        const jobIds = favoriteJobsResponse.data.map(job => job.job);

        if (jobIds.length > 0) {
          const allJobsResponse = await axios.get<Job[]>("/jobs/");
          const favoriteJobsData = allJobsResponse.data.filter(job => jobIds.includes(job.id));
          setFavoriteJobs(favoriteJobsData);
        } else {
          setFavoriteJobs([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, []);

  const favoriteJobBoxes = favoriteJobs.map(job => {
    return (
      <Col key={job.id} style={{ marginBottom: "1em", padding: 0 }}>
        <SingleJobPostingBox job={job} />
      </Col>
    );
  });

  const history = useHistory();

  const handleButtonClick = () => {
    history.push("/student-profile");
  };

  return (
    <>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Card style={{ width: "80%" }}>
          <Row align="middle">
            <Col>
              <Button style={{ width: "3.5rem", height: "3rem", fontSize: "1.5rem" }} onClick={handleButtonClick}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </Button>
            </Col>
            <Col>
              <Title style={{ margin: 0, paddingLeft: "1rem" }}> Mine favoritter </Title>
            </Col>
          </Row>
          <br />

          <List
            loading={loading}
            itemLayout="vertical"
            pagination={false}
            locale={{
              emptyText: !loading && (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Du har ikke lagt til noen favoritter" />
              ),
            }}
            style={{ padding: 0, margin: 0 }}
            dataSource={favoriteJobBoxes}
            renderItem={item => item}
          />
        </Card>
      </div>
    </>
  );
};

export default MyFavorites;
